import { SOLACE_HEALTH as types } from 'actions/actionTypes';

export const initialState = {
  health: {
    state: 'unknown',
    lastCheckAt: null,
    lastSuccessAt: null,
    recentFailureCount: 0,
    recentFailures: [],
    lastError: ''
  },
  inFlight: false,
  error: null
};

export const solaceHealth = (state = initialState, action) => {
  switch (action.type) {
  case types.LOAD_IN_FLIGHT: {
    return { ...state, inFlight: true, error: null };
  }
  case types.LOAD_SUCCESS: {
    const { data } = action;
    return {
      ...state,
      inFlight: false,
      health: {
        state: data.state || 'unknown',
        lastCheckAt: data.last_check_at || null,
        lastSuccessAt: data.last_success_at || null,
        recentFailureCount: data.recent_failure_count || 0,
        recentFailures: data.recent_failures || [],
        lastError: data.last_error || ''
      }
    };
  }
  case types.LOAD_FAILURE: {
    return { ...state, inFlight: false, error: action.error };
  }
  default:
    return state;
  }
};

export default solaceHealth;
